import React, { Fragment, useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom'
import { DataGrid, GridColDef, GridValueGetterParams, GridToolbar, GridApi, gridClasses, GridFilterModel } from '@mui/x-data-grid';
import {
  Grid,
  Segment,
  Header,
  Container,
  Menu, Icon, Label, Button, Input, Modal
} from 'semantic-ui-react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


import DepartmentService from "../../services/departmentServices";

interface IDepartmentsModal {
  Code: string,
  Name: string,
  ID: number,
  IsDeleted: boolean
}




function Departments(props: any) {
  const [departmentDetail, setDepartmentsDetail] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });
  const [previousPgSize, setPreviousPgSize] = useState(paginationModel.pageSize)
  const [data, setData] = useState({
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: [5, 10, 15]
  });

  const updateData = (k: string, v: any) => setData((prev) => ({ ...prev, [k]: v }));
  const [searchText, setSearchText] = React.useState<string | null>(null);
  const [open, setOpen] = React.useState(false);
  const columns: GridColDef[] = [
    { field: 'ID', headerName: 'ID', width: 90, },
    { field: 'Code', headerName: 'DepartmentCode', width: 150, flex: 0 },
    { field: 'Name', headerName: 'DepartmentName', width: 150, flex: 1 },
    {
      field: 'action',
      type: 'actions',
      headerName: 'Action',
      width: 150,
      cellClassName: 'actions',

      renderCell: (params) => {

        const handleClickOpen = (e: any) => {
          e.stopPropagation(); // don't select this row after clicking
          console.log(params.row)
          setOpen(true);
          const api: GridApi = params.api;
        };

        const handleEdit = (e: any) => {
          e.preventDefault();
          console.log(params.row);
          props.setDepartmentData(params.row);
        }

        return (
          <div>
            <Button.Group>
              <Button icon='edit' basic color='blue' onClick={handleEdit} />
              <Button icon='trash' basic color='red' onClick={handleClickOpen} />
            </Button.Group>

          </div>
        );
      }
    },
  ];

  const [activeItem, setActive] = useState('')
  const navigate = useNavigate()



  const getAllDepartments = (param: any) => {
    DepartmentService.getAllDepartments(param).then((response: any) => {
      if (response && response.data) {
        setDepartmentsDetail(response.data);
        const rows = response.data
        console.log(rows);
        updateData("rows", rows);
        updateData("totalRows", response.data[0].Total);
      }
      console.log(response.data);
    })
  }


  const state = { value: "Search" };
  const searchClick = () => {
    console.log(state.value);
  };
  // const searchInputChange = () => {
  //   setState({ value: e.target.value });
  // };

  const handleClose = () => {
    setOpen(false);
  };


  useEffect(() => {
    if (activeItem) {
      props.setDepartmentData(null);
      navigate(`/${activeItem}`)
    }
  }, [activeItem])

  useEffect(() => {
    if (previousPgSize !== paginationModel.pageSize) {
      setPaginationModel({
        ...paginationModel,
        page: 0
      })
      setPreviousPgSize(paginationModel.pageSize);
    }
    const param = {
      pageNumber: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      searchText: searchText
    }
    getAllDepartments(param);
  }, [paginationModel]);

  const onFilterChange = (e: any) => {
    console.log(e.quickFilterValues)
    const searchValue = e.quickFilterValues.length > 0 ? e.quickFilterValues[0] : '';
    setSearchText(searchValue);
    if (searchValue.length === 0 || (searchValue !== null && searchValue !== '' && searchValue.length > 2)) {
      setPaginationModel({
        ...paginationModel,
        page: 0
      })
    }
  }

  return (


    <Container fluid>
      <Grid columns={1}>
        <Grid.Column>

          <Grid className="pt20">
            <Grid.Column floated='left' width={6}>
              <Header as='h2'  >Departments</Header>
            </Grid.Column>
            <Grid.Column textAlign='right' floated='right' width={6}>
              <Button
                floated='right'
                icon
                labelPosition='left'
                primary
                size='small'
                onClick={() => setActive('adddepartments')}
              >
                <Icon name='user' /> Add Departments
              </Button>
            </Grid.Column>
          </Grid>

          {/*
          <Segment>

            <Grid  >
              <Grid.Column textAlign='right' >
                <Input action={{ icon: 'search' , onClick: () => searchClick() }}
                defaultValue={state.value}
                //onChange={searchInputChange}
                placeholder='Search...' />
              </Grid.Column>

            </Grid>


          </Segment> */}

          <div style={{ height: 590, width: '100%', marginTop: '20px' }}>
            <DataGrid
              getRowHeight={() => 'auto'}
              sx={{
                [`& .${gridClasses.cell}`]: {
                  py: 1,
                },
              }}
              slots={{ toolbar: GridToolbar }}
              disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              disableColumnMenu
              className="customInput"
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                },
              }}
              filterMode="server"
              onFilterModelChange={onFilterChange}
              disableRowSelectionOnClick
              rows={data.rows}
              rowCount={data.totalRows}
              getRowId={(r) => r.ID}
              columns={columns}
              pageSizeOptions={data.rowsPerPageOptions}
              paginationModel={paginationModel}
              paginationMode="server"
              onPaginationModelChange={setPaginationModel} />
          </div>
        </Grid.Column>
      </Grid>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Delete Your Account"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete your account
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button negative onClick={handleClose}>No</Button>
          <Button positive onClick={handleClose} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

    </Container>



  );
}
export default Departments;
